import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/header/Header";

const PartnershipPage = () => {
  return (
    <>

      <Helmet>
        <title>
          {" "}
          Terms and Conditions || Octy AI
        </title>
      </Helmet>
      {/* End Page SEO Content */}
<div>
<h2 id="octy-ai-privacy-policy">Octy.ai Privacy Policy</h2>
<p><strong>Last Updated: May 10, 2025</strong></p>
<h3 id="1-introduction">1. Introduction</h3>
<p>Octy.ai (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) is committed to protecting the privacy of individuals who visit our website (&quot;Visitors&quot;), merchants who register to use our Services (&quot;Merchants&quot;), and end users who visit or interact with Merchants&#39; Shopify stores where our Services are installed (&quot;End Users&quot;). This Privacy Policy describes how we collect, use, share, and protect personal information.</p>
<h3 id="2-information-we-collect">2. Information We Collect</h3>
<h3 id="2-1-information-from-merchants">2.1 Information from Merchants</h3>
<p>When you register for our Service, we collect:</p>
<ul>
<li>Name and contact information</li>
<li>Billing information</li>
<li>Shopify store information</li>
<li>Account credentials</li>
<li>Communication preferences</li>
<li>Service usage data</li>
</ul>
<h3 id="2-2-information-from-end-users">2.2 Information from End Users</h3>
<p>When our Service is installed on a Merchant&#39;s Shopify store, we collect:</p>
<ul>
<li>Browsing behavior (pages viewed, products viewed, time spent)</li>
<li>Device information (type, operating system, browser)</li>
<li>IP address and approximate location</li>
<li>Referral source</li>
<li>Shopping cart activity</li>
<li>Purchase history</li>
<li>Identifiers (cookies, device IDs)</li>
<li>When available: email address, name, and other account information</li>
</ul>
<h3 id="2-3-information-from-visitors">2.3 Information from Visitors</h3>
<p>When you visit our website, we collect:</p>
<ul>
<li>Device information</li>
<li>IP address</li>
<li>Pages visited</li>
<li>Referral source</li>
<li>Contact information if provided</li>
</ul>
<h3 id="2-4-cookies-and-similar-technologies">2.4 Cookies and Similar Technologies</h3>
<p>We use cookies, pixel tags, and similar technologies to:</p>
<ul>
<li>Remember user preferences</li>
<li>Understand how our Services are used</li>
<li>Recognize return visitors</li>
<li>Collect analytics data</li>
<li>Enable certain site functionality</li>
</ul>
<h3 id="3-how-we-use-information">3. How We Use Information</h3>
<h3 id="3-1-service-provision-and-improvement">3.1 Service Provision and Improvement</h3>
<p>We use collected information to:</p>
<ul>
<li>Provide, maintain, and improve our Services</li>
<li>Develop new features and functionality</li>
<li>Process transactions and send related information</li>
<li>Respond to support requests</li>
<li>Train our machine learning models</li>
</ul>
<h3 id="3-2-personalization">3.2 Personalization</h3>
<p>We use data to:</p>
<ul>
<li>Personalize the user experience</li>
<li>Generate insights for Merchants</li>
<li>Create and optimize coupon delivery</li>
<li>Identify potential customer churn</li>
<li>Analyze customer behavior patterns</li>
</ul>
<h3 id="3-3-communication">3.3 Communication</h3>
<p>We may use your contact information to:</p>
<ul>
<li>Send service announcements and updates</li>
<li>Provide marketing communications</li>
<li>Respond to inquiries</li>
<li>Send promotional materials</li>
</ul>
<h3 id="3-4-legal-and-security">3.4 Legal and Security</h3>
<p>We may use information to:</p>
<ul>
<li>Protect against fraud and abuse</li>
<li>Enforce our Terms of Service</li>
<li>Comply with legal obligations</li>
<li>Resolve disputes</li>
</ul>
<h3 id="4-how-we-share-information">4. How We Share Information</h3>
<h3 id="4-1-with-merchants">4.1 With Merchants</h3>
<p>We provide Merchants with:</p>
<ul>
<li>Analytics and insights about End Users</li>
<li>Reports on Service performance</li>
<li>Customer behavior patterns</li>
<li>Coupon effectiveness metrics</li>
</ul>
<h3 id="4-2-service-providers">4.2 Service Providers</h3>
<p>We may share information with third-party vendors who help us:</p>
<ul>
<li>Host our infrastructure</li>
<li>Process payments</li>
<li>Analyze data</li>
<li>Provide customer support</li>
<li>Send communications</li>
</ul>
<h3 id="4-3-business-transfers">4.3 Business Transfers</h3>
<p>If we are involved in a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.</p>
<h3 id="4-4-legal-requirements">4.4 Legal Requirements</h3>
<p>We may disclose information if required by law, governmental request, or to protect our rights, property, or safety.</p>
<h3 id="4-5-with-consent">4.5 With Consent</h3>
<p>We may share information with third parties when we have your consent to do so.</p>
<h3 id="5-data-retention">5. Data Retention</h3>
<p>We retain information as long as your account is active or as needed to provide services. We will delete or anonymize Merchant data within 90 days of account termination. We may retain anonymized data for analytical purposes indefinitely.</p>
<h3 id="6-your-rights-and-choices">6. Your Rights and Choices</h3>
<h3 id="6-1-merchant-rights">6.1 Merchant Rights</h3>
<p>As a Merchant, you can:</p>
<ul>
<li>Access and update your account information</li>
<li>Opt out of marketing communications</li>
<li>Request deletion of your account and associated data</li>
<li>Export your store&#39;s data</li>
</ul>
<h3 id="6-2-end-user-rights">6.2 End User Rights</h3>
<p>End Users should contact the relevant Merchant to:</p>
<ul>
<li>Access their personal information</li>
<li>Request correction of inaccurate data</li>
<li>Request deletion of their data</li>
<li>Exercise other privacy rights</li>
</ul>
<p>We will cooperate with Merchants to fulfill such requests.</p>
<h3 id="6-3-cookie-choices">6.3 Cookie Choices</h3>
<p>Most web browsers allow you to control cookies through preferences settings. Mobile devices may allow you to limit ad tracking.</p>
<h3 id="7-children-s-privacy">7. Children&#39;s Privacy</h3>
<p>Our Services are not directed to individuals under 16. We do not knowingly collect personal information from children. If we learn we have collected information from a child under 16, we will delete that information.</p>
<h3 id="8-international-data-transfers">8. International Data Transfers</h3>
<p>We may transfer information to countries other than where you are located. We ensure appropriate safeguards are in place to protect your information.</p>
<h3 id="9-data-security">9. Data Security</h3>
<p>We implement appropriate technical and organizational measures to protect the information we collect. However, no security system is impenetrable, and we cannot guarantee the absolute security of your information.</p>
<h3 id="10-changes-to-this-privacy-policy">10. Changes to This Privacy Policy</h3>
<p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting a notice on our website or sending an email.</p>
<h3 id="11-contact-us">11. Contact Us</h3>
<p>If you have questions about this Privacy Policy or our privacy practices, please contact us at:</p>
<p><strong>Email:</strong> privacy@octy.ai</p>
<h3 id="12-additional-information-for-specific-jurisdictions">12. Additional Information for Specific Jurisdictions</h3>
<h3 id="12-1-european-economic-area-eea-and-united-kingdom">12.1 European Economic Area (EEA) and United Kingdom</h3>
<p>If you are in the EEA or UK, the following additional provisions apply:</p>
<p><strong>Legal Basis for Processing:</strong></p>
<ul>
<li>Contract: Processing necessary for the performance of our contract with you</li>
<li>Consent: Processing based on your explicit consent</li>
<li>Legitimate Interests: Processing based on our legitimate business interests</li>
<li>Legal Obligation: Processing to comply with legal requirements</li>
</ul>
<p><strong>Your Rights:</strong></p>
<ul>
<li>Access and portability</li>
<li>Rectification</li>
<li>Erasure</li>
<li>Restriction of processing</li>
<li>Objection to processing</li>
<li>Withdrawal of consent</li>
<li>Lodge a complaint with a supervisory authority</li>
</ul>
<p><strong>Data Controller:</strong> Octy.ai is the data controller for Merchant data. Merchants are the data controllers for End User data, and we act as a data processor.</p>
<h3 id="12-2-california-privacy-rights">12.2 California Privacy Rights</h3>
<p>California residents have specific rights under the California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA):</p>
<ul>
<li>Right to know what personal information is collected</li>
<li>Right to know if personal information is sold or disclosed</li>
<li>Right to opt-out of the sale of personal information</li>
<li>Right to access personal information</li>
<li>Right to request deletion</li>
<li>Right to non-discrimination</li>
</ul>
<p>We do not &quot;sell&quot; personal information as defined by the CCPA/CPRA. To exercise your rights, contact us using the information in Section 11.</p>
<h3 id="12-3-canada">12.3 Canada</h3>
<p>If you are in Canada, we comply with the Personal Information Protection and Electronic Documents Act (PIPEDA) and applicable provincial laws. You have the right to access your personal information and request corrections.</p>
<h3 id="13-shopify-data-processing">13. Shopify Data Processing</h3>
<p>As a Shopify app developer, we adhere to Shopify&#39;s API License and Terms of Use. We only request access to data that is necessary for our app to function properly.</p>
</div>

    </>
  );
};

export default PartnershipPage;
